import { mergeAttributes, Node } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-3';
import IteratorStartWidget from '../editor-widgets/IteratorStartWidget.vue';

export default Node.create({
    name: 'IteratorStartComponent',
    group: 'block',
    content: 'inline*',

    parseHTML() {
        return [
            {
                tag: 'iterator-start-component',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['iterator-start-component', mergeAttributes(HTMLAttributes), 0];
    },

    addNodeView() {
        return VueNodeViewRenderer(IteratorStartWidget);
    },
});
